var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 44.43353,
    viewBox: "0 0 50 44.43353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m34.94692,7.21261l7.82936,7.82935c.32993.33099.32993.8665,0,1.19749l-18.95736,18.95859-8.05527.8938c-.9269.104-1.7626-.5631-1.8666-1.49-.01404-.12514-.01404-.25146,0-.3766l.8938-8.05527L33.7482,7.21261c.33113-.33075.86759-.33075,1.19872,0Zm14.0637-1.98758l-4.23813-4.23565c-1.32466-1.31917-3.46653-1.31917-4.79119,0l-3.06903,3.0752c-.32992.33099-.32992.8665,0,1.19749l7.82936,7.82935c.33099.32993.8665.32993,1.19749,0l3.0715-3.0752c1.31917-1.32466,1.31917-3.46653,0-4.79119Zm-15.67846,24.81641v8.83673H5.55536V11.10136h19.94745c.27694-.00135.54253-.11024.74072-.30369l3.47272-3.47148c.40704-.40676.40728-1.06648.00052-1.47352-.19645-.19659-.46331-.30655-.74123-.30543H4.16652c-2.30034.00068-4.16516,1.86494-4.16652,4.16529v30.55448c.00068,2.30082,1.8657,4.16584,4.16652,4.16652h30.55448c2.30082-.00068,4.16584-1.8657,4.16652-4.16652v-13.69705c.00068-.57613-.46582-1.04372-1.04195-1.0444-.27618-.00032-.54122.10888-.737.30368l-3.47148,3.47272c-.19361.19768-.30293.46279-.30493.73948Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c5f07fffb8a242620c3bac04c0f004f3.svg";
export { ForwardRef as ReactComponent };